import { useCallback } from 'react';
import { useModalHistory } from 'context/ModalRouter';
import { ApiClientError } from 'api/client';
import { modalRoutes } from 'constants/routes';

type SeatErrorData =
  | { code: 'USER_LIMIT_REACHED' }
  | { code: 'SUBSCRIPTION_EXPIRED' };

type SeatErrorResponseBody = {
  error_data?: SeatErrorData;
};

function readSeatErrorData(error: ApiClientError): SeatErrorData | undefined {
  const response = error.response as
    | { data?: SeatErrorResponseBody }
    | undefined;
  return response?.data?.error_data;
}

export function useSeatLimitErrorHandler() {
  const modalHistory = useModalHistory();

  return useCallback(
    (error: ApiClientError): boolean => {
      const errorData = readSeatErrorData(error);

      if (!errorData) {
        return false;
      }

      if (errorData.code === 'USER_LIMIT_REACHED') {
        modalHistory.push({ hash: modalRoutes.USER_LIMIT_REACHED });
        return true;
      }

      if (errorData.code === 'SUBSCRIPTION_EXPIRED') {
        modalHistory.push({ hash: modalRoutes.SUBSCRIPTION });
        return true;
      }

      return false;
    },
    [modalHistory],
  );
}
